//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";

// img
import SearchSvg from "../../../assets/img/icon/icon_search.svg";

// componet
import ProductBox from "../../../component/content/ProductBox";
import Pagination from "../../../component/pagination/Pagination";
import BasicBtn from "../../../component/button/BasicBtn";

// responsive
import { M, MMinus, T } from "../../../utils/MT";

// 임시 데이터
import { ProductData, ProductData2 } from "../../../Data";

export default function SearchResult() {
    // 페이지 이동
    const params = useParams();
    const [searchWord, setsearchWord] = useState(params.searchWord); //검색 중 텍스트
    const [searchedWord, setSearchedWord] = useState(params.searchWord); // 검색결과 텍스트
    const onSearch = () => {
        if (searchWord.length == 0) {
            alert("검색어를 입력해주세요");
            return;
        }
        setsearchWord(searchWord);
    };

    const relatedDataList = ["3D", "필라멘트", "3D PRT", "프린터", "smartStation™"];

    return (
        <Warp>
            <SearchBox>
                <SearchBoxInner>
                    {/* 검색결과 */}
                    <SearchTitle>
                        <SerchThis>‘{searchWord}’</SerchThis>&nbsp;검색결과
                        <SearchNumText>
                            (총 <SearchNum>7</SearchNum>건)
                        </SearchNumText>
                    </SearchTitle>
                    {/* 검색box */}
                    <PC>
                        <SearchBarWrap>
                            <SearchInput
                                value={searchWord}
                                onChange={(e) => {
                                    setsearchWord(e.target.value);
                                }}
                                type="text"
                                placeholder="상품 검색어 입력"
                            />
                            <SearchBtn
                                onClick={() => {
                                    onSearch();
                                }}
                            >
                                <SearchIconImg
                                    onClick={() => {
                                        setSearchedWord(searchWord);
                                    }}
                                    src={SearchSvg}
                                    alt="검색하기"
                                />
                            </SearchBtn>
                        </SearchBarWrap>
                    </PC>

                    {/* 연관검색어 ( 검색결과 없을 시 안뜹니다! ) */}
                    {ProductData.length > 0 || ProductData2.length > 0 ? (
                        <RelatedWrap>
                            <RealatedTitle>연관검색어</RealatedTitle>
                            <RelatedListWrap>
                                {relatedDataList.map((item, index) => {
                                    return (
                                        <RealatedList
                                            key={"relateData" + index}
                                            onClick={() => {
                                                setSearchedWord({ item });
                                            }}
                                        >
                                            {item}
                                        </RealatedList>
                                    );
                                })}
                            </RelatedListWrap>
                        </RelatedWrap>
                    ) : null}
                </SearchBoxInner>
            </SearchBox>
            <ResultBox>
                <SearchListBigWrap>
                    {/* 검색된 아이템 그룹1 */}
                    <ListTitle>
                        3D PRT <ListNum>(1)</ListNum>
                    </ListTitle>
                    <SearchListWrap>
                        {ProductData.map((item, index) => {
                            return (
                                <ProductBox
                                    key={"ProductData" + index}
                                    id={item.id}
                                    productImg={item.productImg}
                                    itemName={item.itemName}
                                    desc={item.desc}
                                    isDiscount={item.isDiscount}
                                    orginPrice={item.orginPrice}
                                    percent={item.percent}
                                    price={item.price}
                                    i={item.id}
                                />
                            );
                        })}
                    </SearchListWrap>
                </SearchListBigWrap>

                {/* 검색된 아이템 그룹2 */}
                <SearchListBigWrap>
                    <ListTitle>
                        Filaments <ListNum>(1)</ListNum>
                    </ListTitle>
                    <SearchListWrap>
                        {ProductData2.map((item, index) => {
                            return (
                                <ProductBox
                                    key={"ProductData2" + index}
                                    id={item.id}
                                    productImg={item.productImg}
                                    itemName={item.itemName}
                                    desc={item.desc}
                                    isDiscount={item.isDiscount}
                                    orginPrice={item.orginPrice}
                                    percent={item.percent}
                                    price={item.price}
                                    i={item.id}
                                />
                            );
                        })}
                    </SearchListWrap>
                </SearchListBigWrap>
                {/*  리스트 6개 이상시 more 버튼 노출 */}
                <MoreBtn>More</MoreBtn>

                {/* 2. 검색 내역 없을시 */}
                {/* <EmptyWrap>
                    <EmptyText>
                        <b>‘Aaa’</b>
                        <span>
                            ‘에 대한 검색 결과가 없습니다.
                            <br />
                            다른 검색어를 입력하시거나 철자와 띄어쓰기를 확인해보세요.
                        </span>
                    </EmptyText>
                </EmptyWrap> */}
            </ResultBox>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: 100%;
`;

const ResultBox = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    padding-top: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        padding-top: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        padding-top: ${M(45)};
    }
`;

const SearchBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    background: #fafafa;
    min-height: calc(100vw * (300 / 1920));

    padding: calc(100vw * (80 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (300 / 1300));
        padding: calc(100vw * (80 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        min-height: ${M(150)};
        padding: ${M(38)} 0;
    }
`;

const SearchBoxInner = styled.div`
    max-width: calc(100vw * (600 / 1920));

    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        max-width: calc(100vw * (600 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: none;
        width: ${M(378)};
    }
`;

const SearchTitle = styled.h2`
    font-size: calc(100vw * (20 / 1920));
    display: flex;
    justify-content: center;
    align-items: baseline;
    flex-wrap: wrap;

    margin-bottom: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-bottom: 0;
    }
`;
const SerchThis = styled.div`
    font-family: "Noto-B";
    word-break: break-all;
    white-space: nowrap;

    color: var(--main-color);

    margin-right: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        margin-right: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-right: ${M(2)};
    }
`;
const SearchNumText = styled.div`
    display: flex;
    align-items: baseline;

    font-size: calc(100vw * (15 / 1920));
    color: #aaa;

    margin-left: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
        margin-left: ${M(5)};
    }
`;
const SearchNum = styled(SerchThis)`
    margin-left: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-left: ${M(5)};
    }
`;

const SearchBarWrap = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (400 / 1920));

    padding: calc(100vw * (10 / 1920)) calc(100vw * (20 / 1920));
    border-radius: 50px;
    border: 1px solid #ddd;
    background: #fff;

    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));

        padding: calc(100vw * (10 / 1300)) calc(100vw * (20 / 1300));
        margin: 0 auto;
    }
`;

const SearchInput = styled.input`
    width: calc(100% - 100vw * (20 / 1920));
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (20 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }
`;

const SearchBtn = styled.div`
    width: calc(100vw * (16 / 1920));
    height: calc(100vw * (16 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (16 / 1300));
        height: calc(100vw * (16 / 1300));
    }
`;

const SearchIconImg = styled.img`
    display: block;
    width: 100%;
    height: 100%;
`;

const RelatedWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;

const RealatedTitle = styled.h4`
    flex-shrink: 0;
    font-family: "Noto-B";
    font-size: calc(100vw * (15 / 1920));

    min-width: calc(100vw * (70 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        min-width: calc(100vw * (70 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        min-width: ${M(60)};
    }
`;

const RelatedListWrap = styled.ul`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;
const RealatedList = styled.li`
    font-family: "Noto-R";
    font-size: calc(100vw * (14 / 1920));
    color: #8c8c8c;

    margin-left: calc(100vw * (15 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-left: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        margin-left: ${M(15)};
    }
`;

const SearchListBigWrap = styled.div`
    position: relative;
    width: 100%;

    margin-bottom: calc(100vw * (50 / 1920));

    &:last-child {
        margin-bottom: calc(100vw * (75 / 1920));
        padding-bottom: calc(100vw * (45 / 1920));
    }

    &:after {
        position: absolute;
        left: 50%;
        bottom: 0;
        content: "";

        background: #ddd;

        width: calc(100vw * (1280 / 1920));
        height: 1px;
        transform: translateX(-50%);
    }

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (50 / 1300));

        &:last-child {
            margin-bottom: calc(100vw * (75 / 1300));
            padding-bottom: calc(100vw * (45 / 1300));
        }

        &:after {
            width: calc(100vw * (1100 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto ${M(40)};

        &:last-child {
            margin-bottom: ${M(30)};
            padding-bottom: ${M(40)};
        }

        &:after {
            width: ${M(378)};
        }
    }
`;

const ListTitle = styled.h3`
    display: flex;
    font-size: calc(100vw * (25 / 1920));

    margin-bottom: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));

        margin-bottom: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(16)};

        margin-bottom: ${M(30)};
    }
`;

const ListNum = styled.span`
    font-family: "Noto-B";
    color: var(--main-color);

    margin-left: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (15 / 1300));
    }
`;

const SearchListWrap = styled.ul`
    width: calc(100vw * (1060 / 1920));

    display: flex;
    flex-wrap: wrap;

    padding-bottom: calc(100vw * (50 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        padding-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 1300px) {
        width: ${M(378)};
        padding-bottom: ${M(40)};
    }
`;

const MoreBtn = styled.p`
    width: calc(100vw * (180 / 1920));

    padding: calc(100vw * (14 / 1920)) 0;
    margin: 0 auto calc(100vw * (422 / 1920));

    font-family: "Pop-M";
    font-size: calc(100vw * (16 / 1920));
    text-align: center;

    border: 1px solid;
    border-radius: 50px;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));

        padding: calc(100vw * (14 / 1300)) 0;
        margin: 0 auto calc(100vw * (422 / 1300));

        font-size: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(150)};

        padding: ${M(10)} 0;
        margin: 0 auto ${M(123)};

        font-size: ${M(14)};
    }
`;

const EmptyWrap = styled.div`
    display: flex;

    max-width: calc(100vw * (600 / 1920));
    min-height: calc(100vh - 100vw * (440 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        max-width: calc(100vw * (600 / 1300));
        /* padding: calc(100vw * (300 / 1300)) 0; */
        min-height: calc(100vh - 100vw * (440 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: ${M(378)};
        /* padding: ${M(282)} 0; */

        min-height: calc(100vh - 100vw * (200 / 428));
    }
`;

const EmptyText = styled.p`
    text-align: center;
    margin: auto;

    & b {
        font-family: "Noto-B";
        font-weight: normal;
        color: var(--main-color);
        font-size: calc(100vw * (15 / 1920));
    }

    & span {
        font-size: calc(100vw * (15 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & b {
            font-size: calc(100vw * (15 / 1300));
        }

        & span {
            font-size: calc(100vw * (15 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & b {
            font-size: ${M(14)};
        }

        & span {
            font-size: ${M(14)};
        }
    }
`;
